import { store } from '../store/configureStore'

import { ROOT_NODE_ID } from '../store/migrations/data-structure-conversion'
import { selectCursorNodeId, moveCursorToBestChildOrSelf } from '../store/cursor'
import { selectParentId } from '../controllers/treeEngine'

export const initCursorFollowsURL = () => {
    store.subscribe(onStoreChange)

    // On page load put cursor to what is in hash
    moveCursorToHash()

    window.addEventListener('hashchange', moveCursorToHash)
}

let cursorNodeId
const onStoreChange = () => {
    const previousValue = cursorNodeId
    cursorNodeId = selectCursorNodeId(store.getState())
    if (previousValue !== cursorNodeId) {
        onCursorNodeChange()
    }
}

export const getUrlHashForCurrentTitleNode = () => {
    const titleNodeId = selectParentId(cursorNodeId)
    return titleNodeId === ROOT_NODE_ID ? '' : `#${titleNodeId}`
}

let titleNodeId
const onCursorNodeChange = () => {
    const previousValue = titleNodeId
    titleNodeId = selectParentId(cursorNodeId)
    if (previousValue !== titleNodeId) {
        const path = window.location.pathname + window.location.search
        const hash = getUrlHashForCurrentTitleNode()
        history.pushState('', document.title, path + hash)
    }
}

const moveCursorToHash = () => {
    const hash = window.location.hash.substring(1)
    const routeHashNode = hash === ROOT_NODE_ID ? '' : hash
    store.dispatch(moveCursorToBestChildOrSelf(routeHashNode))
}
